import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/background.png'


const _withScopeId = n => (_pushScopeId("data-v-2b151537"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "background-image"
}
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Reset password", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Insert the email you want to recover.", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "container"
}

import { sendOutline } from "ionicons/icons";
import {
  IonLabel,
  IonLoading,
  IonItem,
  IonInput,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
} from "@ionic/vue";
import { reactive } from "vue";
import { useMyAccount } from "../";
import { requestResetPassword } from "@/api/auth";
import { useToasters } from "@/composition/toasters";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const { loginForm } = useMyAccount();
const { isMobile } = useWindowWidth();

const state = reactive({
  loading: false,
  errorMessage: "",
});

const toasters = useToasters();

const resetPassword = () => {
  state.loading = true;
  requestResetPassword(loginForm)
    .then(() => {
      loginForm.email = "";
      state.loading = false;

      toasters.addSuccess(
        "We've sent you an email with the details to reset your password."
      );
    })
    .catch(() => {
      state.loading = false;
      toasters.addError("We could not find an account with this email.");
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("section", {
              style: _normalizeStyle(_unref(isMobile) ? '' : 'text-align: center;')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ container: !_unref(isMobile) })
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ container: _unref(isMobile) })
                }, _hoisted_6, 2),
                _createElementVNode("div", {
                  style: _normalizeStyle(_unref(isMobile) ? '' : 'max-width: 600px; margin: 0 auto')
                }, [
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Email")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(loginForm).email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(loginForm).email) = $event)),
                        name: "email",
                        placeholder: "john.doe@email.com",
                        type: "email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(IonButton), {
                          expand: "block",
                          color: "primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (resetPassword())),
                          class: "ion-margin-top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              slot: "start",
                              icon: _unref(sendOutline)
                            }, null, 8, ["icon"]),
                            _createTextVNode(" Reset password ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), {
                          expand: "block",
                          color: "dark",
                          fill: "clear",
                          "router-link": "/login",
                          class: "ion-margin-top"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Back to login ")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ], 4)
              ], 2)
            ], 4),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("section", null, [
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      color: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (resetPassword())),
                      class: "ion-margin-top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          icon: _unref(sendOutline)
                        }, null, 8, ["icon"]),
                        _createTextVNode(" Reset password ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      color: "dark",
                      fill: "clear",
                      "router-link": "/login",
                      class: "ion-margin-top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Back to login ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})